import { AppView, PLATFORM_OVERLAY_EXTRASMALL } from '@gaming/srvg-classes-core';
import { MatchdayPickerLeagueView } from "../MatchdayPickerLeagueView";
import { ChunkIndicatorView } from "../ChunkIndicatorView";
import { ChunkAreaView } from "../ChunkAreaView";
import { VideoAreaView } from "../VideoAreaView";
import { LivetableLeagueWidget } from "../../../widgets/View/VfWidget/LivetableLeagueWidget";
import { LivescoreWidget } from "../../../widgets/View/VfWidget/LivescoreWidget";
import { TickerWidget } from "../../../widgets/View/VfWidget/TickerWidget";
import { DesktopLayoutTemplateParser } from "../../DesktopLayoutTemplateParser";
import { TimelineWidget } from "../../../widgets/View/VfWidget/TimelineWidget";

/**
 * Main view class for VF Desktop views.
 */
export class DesktopView extends AppView {
    chunkIndicatorView:ChunkIndicatorView;
    livescoreWidget:LivescoreWidget;
    tickerWidget:TickerWidget;
    videoAreaView:VideoAreaView;
    chunkAreaView:ChunkAreaView;
    matchdayPickerLeagueView:MatchdayPickerLeagueView;

    parser:DesktopLayoutTemplateParser;

    constructor(options) {
        options = options || {};
        options.name = options.name || "cupView";
        options.selector = "#" + options.name;
        super(options);
        this.isExpanded = true;

        this.videoAreaView = this.addSubView( new VideoAreaView( {} ) );
        this.chunkAreaView = this.addSubView(new ChunkAreaView({chunkPickerView: true}));

        this.chunkIndicatorView = this.addSubView(new ChunkIndicatorView({}));
        if ($('div[data-class="ChunkAreaView"]').length === 1) {
            $('div[data-class="ChunkAreaView"]').attr('id', '#chunkAreaView');
        }

        if (srvg.product.mode == "VFLM" || srvg.product.mode == "VFB"){
            srvg.widgets.widgets['cuproster'].enabled = false;
            // LEAGUE

            // new subview for matchday picker
            this.matchdayPickerLeagueView = this.addSubView(new MatchdayPickerLeagueView({
                matchdayPickerLeagueView: true
            }));


            if ( srvg.widgets.widgets["livetableLeague"].enabled) {
                this.videoAreaView.addSubView(new LivetableLeagueWidget({
                    widgetGroup: srvg.widgets.widget_group,
                    selector: "#livetableWidget",
                    platform: PLATFORM_OVERLAY_EXTRASMALL,
                    form: true,
                    games: true,
                    showHeader: false
                }));
            }

        }else{
            // CUP

        }

        if (srvg.product.mode !== "VFWC" && srvg.product.mode !== "VFCC"){
            if (srvg.widgets.widgets["timeline"].enabled) {
                this.videoAreaView.addSubView(new TimelineWidget({
                    widgetGroup: srvg.widgets.widget_group,
                    selector: "#eventtimelineWidget",
                    showAbbreviations: false,
                    platform: PLATFORM_OVERLAY_EXTRASMALL
                }));
            }
        }



        this.parser = new DesktopLayoutTemplateParser({});
        this.parser.desktopView = this;
        this.parser.initialize(options.selector);
    }

    handleDomInstantiated(){
        super.handleDomInstantiated();
    }

    /**
     * overwrites the parent method, only overwriteDom is different
     * @param subView
     * @param $domNode
     * @param append
     * @param overwriteDom  added only for DesktopViews, because of an engine error which creates duplicated ids etc. To fix this for now, we added this option
     * @returns {any} subView
     */
    addSubView( subView, $domNode?, append?:boolean, overwriteDom?:boolean ):any { // Actually, it's a View, but the return value must be any
        append = typeof append !== "undefined" && append !== null  ? append : true;
        overwriteDom = typeof overwriteDom !== "undefined" && overwriteDom !== null  ? overwriteDom : false;

        this.subViews.push( subView );
        subView.superView = this;
        // if there is a template
        if( subView.$templateDomNode ) {
            // instantiate it
            if( ! $domNode ) {
                $domNode = this.$domNode;
            }
            // console.log( this.name, 'addSubView()', subView, append, this.$domNode, "overwriteDom", overwriteDom );
            if (overwriteDom){
                $domNode.replaceWith(subView.$domNode);
            }else{
                if (append){
                    // $domNode.append( subView.$domNode );
                }else{
                    $domNode.prepend( subView.$domNode );
                }
            }
        }
        subView.handleDomInstantiated();
        this.subViewsBySelector[subView.selector] = subView;
        return <any>subView;
    }

    // hide all elements that would still be shown after other elements are already enabled
    handleTimeoutEvent( event, provider ) {
        $('#textLinkView').hide();
        $('#CrossMatchTickerHead').hide();
        $('#eventtimelineWidget').hide();
        $('#livetableWidget').hide();
    }
}
